import React, { Component, Fragment } from "react";
import { Tabs, Icon } from "antd";

const { TabPane } = Tabs;
// Facebook
const facebookStyles = {
    background: "#e9ebee",
    padding: 10,
    maxWidth: 500,
};
const facebookStylesCard = {
    background: "#fff",
    border: "1px solid #dddfe2",
    borderRadius: 3,
    padding: 12,
    position: "relative",
};
const facebookStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 40,
    height: 40,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
};
const facebookStylesAuthor = {
    color: "#3b5a99",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 50,
};
const facebookStylesDate = {
    color: "rgb(97, 103, 112)",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16.0833px",
    marginLeft: 50,
};
const facebookStylesBody = {
    color: "rgb(29, 33, 41)",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19.3167px",
    overflowWrap: "break-word",
    marginTop: 12,
    marginBottom: 5,
    whiteSpace: "break-spaces",
};
// Twitter
const twitterStyles = {
    background: "#fff",
    padding: 10,
    maxWidth: 600,
};
const twitterStylesCard = {
    background: "#fff",
    border: "1px solid #dddfe2",
    borderRadius: 0,
    padding: "10px 15px",
    position: "relative",
    paddingLeft: 75,
};
const twitterStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 48,
    height: 48,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    left: 15,
};
const twitterStylesAuthor = {
    color: "#000",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 0,
};
const twitterStylesHandleAndDate = {
    color: "#667782",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 0,
};
const twitterStylesBody = {
    color: "rgb(29, 33, 41)",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19.3167px",
    overflowWrap: "break-word",
    marginTop: 5,
    marginBottom: 9,
    whiteSpace: "break-spaces",
};
const twitterStylesImage = {
    border: "1px solid #ccd6dd",
    borderRadius: 10,
    width: "100%",
};
// Linkedin
const linkedinStyles = {
    background: "#f5f5f5",
    padding: 10,
    maxWidth: 600,
};
const linkedinStylesCard = {
    background: "#fff",
    border: "1px solid #c2c2c2",
    borderRadius: 3,
    padding: "10px 15px",
    position: "relative",
    paddingLeft: 0,
    paddingBottom: 0,
    overflow: "hidden",
    boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
};
const linkedinStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 44,
    height: 44,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    left: 15,
};
const linkedinStylesAuthor = {
    color: "#313131",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 70,
};
const linkedinStylesHandleAndDate = {
    color: "#6d6d6d",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 0,
    display: "block",
};
const linkedinStylesBody = {
    color: "#191919",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19.3167px",
    overflowWrap: "break-word",
    marginTop: 15,
    marginBottom: 9,
    marginLeft: 15,
    whiteSpace: "break-spaces",
};
const linkedinStylesImage = {
    width: "calc(100% + 15px)",
};
// Instagram
const instagramStyles = {
    background: "#fafafa",
    padding: 10,
    maxWidth: 600,
};
const instagramStylesCard = {
    background: "#fff",
    border: "1px solid #dbdbdb",
    borderRadius: 3,
    padding: "10px 15px",
    position: "relative",
    paddingLeft: 0,
    paddingBottom: 0,
    overflow: "hidden",
};
const instagramStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 30,
    height: 30,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 16,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    left: 15,
};
const instagramStylesAuthor = {
    color: "#313131",
    fontWeight: 600,
    fontSize: "13.8px",
    lineHeight: 1.38,
    marginLeft: 60,
    marginTop: 6,
    marginBottom: 15,
};
const instagramStylesBody = {
    color: "#191919",
    fontWeight: 400,
    fontSize: "13.8px",
    lineHeight: "19.3167px",
    overflowWrap: "break-word",
    marginTop: 15,
    marginBottom: 15,
    marginLeft: 15,
    whiteSpace: "break-spaces",
};
const instagramStylesImage = {
    width: "calc(100% + 15px)",
};
// Inspiring crates delivered every month for kids of all
//                     ages✨. Get 50% off your first month with promo code:
//                     Weekend50

const FacebookPreview = (props) => {
    //console.info("FacebookPreview props", props);
    return (
        <div style={facebookStyles}>
            <div style={facebookStylesCard}>
                <div style={facebookStylesAvatar} />
                <div style={facebookStylesAuthor}>Sample Facebook Page</div>
                <div style={facebookStylesDate}>Yesterday at 12:30 PM</div>
                <div style={facebookStylesBody}>{props.body}</div>
                <img
                    src={props.image_url}
                    style={{
                        width: "calc(100% + 24px)",
                        borderTop: "1px solid #c4c8ce",
                        // borderBottom: "1px solid #c4c8ce",
                        marginLeft: -12,
                        marginBottom: -12,
                    }}
                    alt=""
                />
                {props.children}
            </div>
        </div>
    );
};

const TwitterPreview = (props) => {
    //console.info("TwitterPreview props", props);
    return (
        <div style={twitterStyles}>
            <div style={twitterStylesCard}>
                <div style={twitterStylesAvatar} />
                <div style={twitterStylesAuthor}>
                    Sample Twitter Account{" "}
                    <span style={twitterStylesHandleAndDate}>
                        @natgeo &middot; 3d
                    </span>
                </div>
                <div style={twitterStylesBody}>{props.body}</div>
                <img src={props.image_url} style={twitterStylesImage} alt="" />
                {props.children}
            </div>
        </div>
    );
};

const LinkedinPreview = (props) => {
    //console.info("LinkedinPreview props", props);
    return (
        <div style={linkedinStyles}>
            <div style={linkedinStylesCard}>
                <div style={linkedinStylesAvatar} />
                <div style={linkedinStylesAuthor}>
                    Sample LinkedIn Account{" "}
                    <span style={linkedinStylesHandleAndDate}>
                        @natgeo &middot; 3d
                    </span>
                </div>
                <div style={linkedinStylesBody}>{props.body}</div>
                <img src={props.image_url} style={linkedinStylesImage} alt="" />
                {props.children}
            </div>
        </div>
    );
};

const InstagramPreview = (props) => {
    //console.info("InstagramPreview props", props);
    return (
        <div style={instagramStyles}>
            <div style={instagramStylesCard}>
                <div style={instagramStylesAvatar} />
                <div style={instagramStylesAuthor}>
                    Sample Instagram Account{" "}
                </div>

                <img
                    src={props.image_url}
                    style={instagramStylesImage}
                    alt=""
                />
                <div style={instagramStylesBody}>
                    <strong>@natgeo </strong>&middot;&nbsp;{props.body}
                </div>
                {props.children}
            </div>
        </div>
    );
};

const YoutubePreview = (props) => {
    //console.info("YoutubePreview props", props);
    return (
        <div style={instagramStyles}>
            <div style={instagramStylesCard}>
                <div style={instagramStylesAvatar} />
                <div style={instagramStylesAuthor}>Sample Youtube Account </div>

                <img
                    src={props.image_url}
                    style={instagramStylesImage}
                    alt=""
                />
                <div style={instagramStylesBody}>
                    <strong>@natgeo </strong>&middot;&nbsp;{props.body}
                </div>
                {props.children}
            </div>
        </div>
    );
};

class SocialPreview extends Component {
    state = {
        size: "small",
    };

    // constructor(props) {
    //     super(props);
    // }

    handleSizeChange = (e) => {
        this.setState({ size: e.target.value });
    };
    render() {
        let content =
            this.props.hideTabs === true ? (
                this.props.defaultTab === "facebook" ? (
                    <FacebookPreview {...this.props}></FacebookPreview>
                ) : (
                    <TwitterPreview {...this.props}></TwitterPreview>
                )
            ) : (
                <Fragment>
                    <Tabs
                        //defaultActiveKey="1"
                        style={{ marginBottom: 30 }}
                        animated={false}
                        className="social_PreviewTabs"
                    >
                        {/* {this.props.includes &&
                        !this.props.includes.includes("facebook") &&
                        !this.props.includes.includes("instagram") &&
                        !this.props.includes.includes("twitter") &&
                        !this.props.includes.includes("linkedin") ? (
                            <TabPane
                                tab={
                                    // <span>
                                    //     <Icon type="warning" />
                                    //     Please select at least one social
                                    //     network
                                    // </span>
                                }
                                key="1"
                            ></TabPane>
                        ) : null} */}

                        {!this.props.includes ||
                        this.props.includes.includes("facebook") ? (
                            <TabPane
                                tab={
                                    <span>
                                        {/* <Icon type="facebook" theme="filled" /> */}
                                        <div
                                            className="social_iconCircle_facebook"
                                            style={{
                                                width: 18,
                                                height: 15,
                                                float: "left",
                                                marginRight: 5,
                                                marginTop: 3,
                                            }}
                                        />
                                        Facebook
                                    </span>
                                }
                                key="1"
                            >
                                <FacebookPreview
                                    {...this.props}
                                ></FacebookPreview>
                            </TabPane>
                        ) : null}
                        {!this.props.includes ||
                        this.props.includes.includes("instagram") ? (
                            <TabPane
                                tab={
                                    <span>
                                        {/* <Icon type="instagram" theme="filled" /> */}
                                        <div
                                            className="social_iconCircle_instagram"
                                            style={{
                                                width: 18,
                                                height: 15,
                                                float: "left",
                                                marginRight: 5,
                                                marginTop: 3,
                                            }}
                                        />
                                        Instagram
                                    </span>
                                }
                                key="2"
                            >
                                <InstagramPreview
                                    {...this.props}
                                ></InstagramPreview>
                            </TabPane>
                        ) : null}
                        {!this.props.includes ||
                        this.props.includes.includes("twitter") ? (
                            <TabPane
                                tab={
                                    <span>
                                        {/* <Icon type="twitter" /> */}
                                        <div
                                            className="social_iconCircle_twitter"
                                            style={{
                                                width: 18,
                                                height: 15,
                                                float: "left",
                                                marginRight: 5,
                                                marginTop: 3,
                                            }}
                                        />
                                        Twitter
                                    </span>
                                }
                                key="3"
                            >
                                <TwitterPreview
                                    {...this.props}
                                ></TwitterPreview>
                            </TabPane>
                        ) : null}
                        {!this.props.includes ||
                        this.props.includes.includes("linkedin") ? (
                            <TabPane
                                tab={
                                    <span>
                                        {/* <Icon type="linkedin" theme="filled" /> */}
                                        <div
                                            className="social_iconCircle_linkedin"
                                            style={{
                                                width: 18,
                                                height: 15,
                                                float: "left",
                                                marginRight: 5,
                                                marginTop: 3,
                                            }}
                                        />
                                        Linkedin
                                    </span>
                                }
                                key="4"
                            >
                                <LinkedinPreview
                                    {...this.props}
                                ></LinkedinPreview>
                            </TabPane>
                        ) : null}
                        {!this.props.includes ||
                        this.props.includes.includes("youtube") ? (
                            <TabPane
                                tab={
                                    <span>
                                        {/* <Icon type="instagram" theme="filled" /> */}
                                        <div
                                            className="social_iconCircle_youtube"
                                            style={{
                                                width: 18,
                                                height: 15,
                                                float: "left",
                                                marginRight: 5,
                                                marginTop: 3,
                                            }}
                                        />
                                        YouTube
                                    </span>
                                }
                                key="5"
                            >
                                <YoutubePreview
                                    {...this.props}
                                ></YoutubePreview>
                            </TabPane>
                        ) : null}
                    </Tabs>
                </Fragment>
            );

        return content;
    }
}

export default SocialPreview;
